import { useFallbackStorageValue } from "~/lib/hooks";
export const useIsFirstTimeVisitNotificationPanel = () => {
  const {
    set: setIsFirstTime,
    value: isFirstTime
  } = useFallbackStorageValue("isFirstTimeVisitNotification", {
    defaultValue: true
  });
  return {
    isFirstTime,
    setIsFirstTime
  };
};